import { render, staticRenderFns } from "./CMSAnswerListing.vue?vue&type=template&id=7b472ca6&scoped=true"
import script from "./CMSAnswerListing.vue?vue&type=script&lang=js"
export * from "./CMSAnswerListing.vue?vue&type=script&lang=js"
import style0 from "./CMSAnswerListing.vue?vue&type=style&index=0&id=7b472ca6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b472ca6",
  null
  
)

export default component.exports